import { Grid, Typography } from '@mui/material'
import React from 'react'

import { labels } from './Labels'

export const DetailPanelGridItem = ({
  fieldTitle,
  fieldValue
}: {
  fieldTitle: string
  fieldValue: string
}) => {
  return (
    <Grid item key={fieldTitle} xs={6} aria-label="customerDetailField">
      <Grid container>
        <Grid item xs={5} key={fieldTitle + 'title'}>
          <Typography variant="subtitle1" aria-label="customerDetailFieldTitle">
            {labels[fieldTitle]}
          </Typography>
        </Grid>
        <Grid item xs={7} key={fieldTitle + 'value'}>
          <Typography aria-label="customerDetailFieldContent">
            {fieldValue}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  )
}
